// Talabalar bo'limi uchun kontent: rivojlanish tavsiyalari, pedagogik keyslar,
// refleksiv kundalik savollari va ijodiy topshiriq generatori.

// Har bir kompetensiya komponentini oshirish uchun aniq harakatlar
export const growthActions = {
    motivational: [
        { text: "Xorijiy davlatlarning maktabgacha ta'lim tajribasi bilan tanishing va o'zingizga yoqqan 3 ta g'oyani yozib oling.", path: "/experiments", link: "Xorij tajribasi" },
        { text: "Tajribali tarbiyachining mashg'ulotini kuzating va eng ko'p ta'sir qilgan lahzani kundalikka yozing.", path: "/reflection", link: "Refleksiv kundalik" },
        { text: "O'zingiz uchun SMART kasbiy maqsad qo'ying: \"Semestr oxirigacha 3 ta metodni amaliyotda sinab ko'raman\".", path: "/method/SMART", link: "SMART metodi" },
        { text: "Ijodiy topshiriqlar generatoridan har hafta bitta topshiriqni bajaring.", path: "/challenge", link: "Ijodiy topshiriq" },
    ],
    cognitive: [
        { text: "7 ta metodning har birini o'rganib, nomi va bosqichlarini bitta grafik organayzerga joylang.", path: "/methods", link: "Metodlar" },
        { text: "Har bir metod bo'yicha bilim testidan 80%+ natija bilan o'ting.", path: "/quiz", link: "Bilim testi" },
        { text: "Metodlarni qiyoslash vositasi orqali qaysi metod qaysi vaziyatga mosligini tahlil qiling.", path: "/compare", link: "Qiyoslash" },
        { text: "Bitta xorijiy tajriba haqida 1 sahifalik annotatsiya yozing.", path: "/experiments", link: "Tajribalar" },
    ],
    activity: [
        { text: "Pedagogik keyslar trenajyorida barcha vaziyatlarni yeching va izohlarni o'qing.", path: "/cases", link: "Keyslar" },
        { text: "Generator yordamida mashg'ulot rejasini tuzing va uni guruhdoshingiz bilan almashib tekshiring.", path: "/planner", link: "Mashg'ulot rejasi" },
        { text: "Pedagogik amaliyotda kamida 2 ta mashg'ulotni yangi metod asosida o'tkazing.", path: "/recommender", link: "Metod tavsiyachi" },
        { text: "Ijodiy topshiriq asosida bolalar uchun didaktik o'yin yarating.", path: "/challenge", link: "Ijodiy topshiriq" },
    ],
    reflexive: [
        { text: "Har bir mashg'ulotdan so'ng refleksiv kundalikka yozuv qoldiring.", path: "/reflection", link: "Refleksiv kundalik" },
        { text: "Keyslarda noto'g'ri javob berganingizda izohni o'qib, nima uchun shunday tanlaganingizni tahlil qiling.", path: "/cases", link: "Keyslar" },
        { text: "Kirish diagnostikasidagi eng past komponentingiz uchun shaxsiy rivojlanish rejasini tuzing.", path: "/diagnostics", link: "Diagnostika" },
        { text: "Guruhdoshingiz mashg'ulotini kuzatib, \"2 yulduz va 1 tilak\" usulida fikr bildiring.", path: "/reflection", link: "Refleksiv kundalik" },
    ],
};

// Pedagogik vaziyatli masalalar. Har bir variantda ball (0–2) va izoh bor.
export const cases = [
    {
        id: 1,
        title: "Yig'layotgan yangi bola",
        age: "3–4 yosh",
        situation: "Guruhga yangi kelgan bola ertalabdan beri onasini so'rab yig'layapti. Boshqa bolalar ham bezovtalana boshladi, mashg'ulot boshlanishiga 10 daqiqa qoldi.",
        options: [
            { text: "Bolani boshqa xonaga olib chiqib, tinchlanguncha yolg'iz qoldiraman.", score: 0, feedback: "Yolg'izlik bolada qo'rquv va xavotirni kuchaytiradi. Moslashuv davrida bola kattalar ko'magiga muhtoj." },
            { text: "Bolani quchoqlab, sevimli o'yinchog'i haqida so'rayman va unga mashg'ulotda \"yordamchi\" rolini beraman.", score: 2, feedback: "To'g'ri! Emotsional qo'llab-quvvatlash va faoliyatga jalb qilish moslashuvni yengillashtiradi. Bu 3I metodidagi individualizatsiya tamoyiliga mos." },
            { text: "Onasiga qo'ng'iroq qilib, bolani olib ketishni so'rayman.", score: 0, feedback: "Bu moslashuv jarayonini uzaytiradi va bolada \"yig'lasam, ketaman\" degan xulq modelini shakllantiradi." },
            { text: "E'tibor bermay, mashg'ulotni boshlayman — o'zi tinchlanadi.", score: 1, feedback: "Ba'zan bola o'zi tinchlanadi, lekin e'tiborsizlik ishonchni susaytiradi. Avval qisqa emotsional aloqa o'rnatish kerak." },
        ],
    },
    {
        id: 2,
        title: "Zerikkan guruh",
        age: "5–6 yosh",
        situation: "\"Uy hayvonlari\" mavzusidagi mashg'ulotning 7-daqiqasida bolalarning ko'pchiligi chalg'iy boshladi, ba'zilari bir-biri bilan gaplashmoqda.",
        options: [
            { text: "Ovozimni ko'tarib, tartibga chaqiraman.", score: 0, feedback: "Bu vaqtincha natija beradi, lekin qiziqishni so'ndiradi. Muammo — faoliyat shaklida." },
            { text: "Mavzuni tezroq tugatib, mashg'ulotni yakunlayman.", score: 0, feedback: "Maqsadga erishilmaydi. Mashg'ulot shaklini o'zgartirish samaraliroq." },
            { text: "\"Hayvonni ovozidan top\" harakatli o'yiniga o'taman va keyin mavzuni davom ettiraman.", score: 2, feedback: "To'g'ri! Maktabgacha yoshda yetakchi faoliyat — o'yin. Faoliyat turini almashtirish e'tiborni qayta tiklaydi (WHERETO dagi \"Hook\")." },
            { text: "Gaplashayotgan bolalarni alohida o'tqazaman.", score: 1, feedback: "Bu ba'zi bolalarga yordam beradi, lekin butun guruh zerikkani — mashg'ulot metodikasini qayta ko'rish kerakligini bildiradi." },
        ],
    },
    {
        id: 3,
        title: "Ota-onaning e'tirozi",
        age: "Ota-onalar bilan ishlash",
        situation: "Ota-ona: \"Bog'chada faqat o'ynashadi, bolam hali harflarni bilmaydi. Maktabga tayyorlash o'rniga vaqt bekor ketyapti\", — deb shikoyat qildi.",
        options: [
            { text: "\"Bu davlat dasturi, men hech narsa qila olmayman\", deb javob beraman.", score: 0, feedback: "Bu ota-ona bilan hamkorlikni buzadi va tarbiyachining kasbiy pozitsiyasini zaiflashtiradi." },
            { text: "Bolaga qo'shimcha harf yodlash topshiriqlarini beraman.", score: 0, feedback: "O'yinsiz, majburiy akademik yuklama maktabgacha yoshdagi bola rivojlanishiga mos emas." },
            { text: "O'yin orqali qaysi ko'nikmalar rivojlanayotganini misollar va bolaning ishlari (portfolio) bilan tushuntiraman, ochiq mashg'ulotga taklif qilaman.", score: 2, feedback: "To'g'ri! Asosli tushuntirish va ota-onani jarayonga jalb qilish — hamkorlikning eng samarali yo'li. Koreya va Germaniya tajribasida ham shunday yondashuv qo'llaniladi." },
            { text: "Mudiraga murojaat qilishini maslahat beraman.", score: 1, feedback: "Ba'zan zarur, lekin avval tarbiyachi o'zi kasbiy tushuntirish berishi kerak." },
        ],
    },
    {
        id: 4,
        title: "Maqsadni belgilash",
        age: "4–5 yosh",
        situation: "Siz \"Fasllar\" mavzusida mashg'ulot rejalashtiryapsiz. Metodist sizdan mashg'ulot maqsadini SMART talablari asosida yozishni so'radi.",
        options: [
            { text: "\"Bolalarga fasllar haqida ma'lumot berish.\"", score: 0, feedback: "Maqsad tarbiyachi faoliyatiga qaratilgan va o'lchab bo'lmaydi." },
            { text: "\"Mashg'ulot oxirida bolalar 4 faslni nomlaydi va har biriga xos 2 ta belgini rasm orqali ko'rsata oladi.\"", score: 2, feedback: "To'g'ri! Aniq (Specific), o'lchanadigan (Measurable), erishsa bo'ladigan (Achievable), mavzuga mos (Relevant) va vaqtga bog'langan (Time-bound)." },
            { text: "\"Bolalar tabiatni sevishni o'rgansin.\"", score: 1, feedback: "Muhim tarbiyaviy maqsad, lekin bitta mashg'ulot doirasida o'lchab bo'lmaydi." },
            { text: "\"Fasllar mavzusini o'tish.\"", score: 0, feedback: "Bu maqsad emas, mavzu nomi." },
        ],
    },
    {
        id: 5,
        title: "Iqtidorli bola",
        age: "5–6 yosh",
        situation: "Guruhdagi bir bola topshiriqlarni boshqalardan ancha tez bajaradi va keyin zerikib, boshqalarga xalaqit beradi.",
        options: [
            { text: "Unga murakkablashtirilgan qo'shimcha topshiriq va \"kichik yordamchi\" vazifasini beraman.", score: 2, feedback: "To'g'ri! Differensial yondashuv — har bir bolaning imkoniyatiga mos topshiriq berish (3I: individualizatsiya + interaksiya)." },
            { text: "Boshqalar tugatguncha jim o'tirishini talab qilaman.", score: 0, feedback: "Bu bolaning qiziqishini so'ndiradi va salbiy xulqni kuchaytiradi." },
            { text: "Ota-onasiga uni maxsus to'garakka berishni maslahat beraman.", score: 1, feedback: "Foydali qo'shimcha chora, lekin guruhdagi muammo hal bo'lmaydi." },
            { text: "Unga o'yinchoq berib, chetga o'tqazaman.", score: 0, feedback: "Bola mashg'ulot jarayonidan chetlashtiriladi va rivojlanish imkoniyati boy beriladi." },
        ],
    },
    {
        id: 6,
        title: "Ikki tilli guruh",
        age: "5–6 yosh",
        situation: "Guruhingizda bir nechta bola o'zbek tilini yaxshi bilmaydi (oilada rus yoki boshqa tilda gaplashiladi). Mashg'ulot mazmunini ular yaxshi tushunmayapti.",
        options: [
            { text: "Ular uchun alohida mashg'ulot o'tkazaman.", score: 1, feedback: "Ba'zan zarur, lekin bolalarni guruhdan ajratish ijtimoiy moslashuvga to'sqinlik qiladi." },
            { text: "Ko'rgazmali vositalar, imo-ishora va juftlikda ishlash orqali mazmun va tilni birga o'rgataman.", score: 2, feedback: "To'g'ri! Bu CLIL yondashuvining asosiy g'oyasi — mazmun va til integratsiyasi, vizual qo'llab-quvvatlash bilan." },
            { text: "Hammasini tarjima qilib beraman.", score: 0, feedback: "Doimiy tarjima bolaning yangi tilni o'zlashtirish motivatsiyasini pasaytiradi." },
            { text: "Bu ota-onaning muammosi deb hisoblayman.", score: 0, feedback: "Inklyuziv muhit yaratish — tarbiyachining kasbiy vazifasi." },
        ],
    },
];

// Refleksiv kundalik uchun yo'naltiruvchi savollar
export const reflectionPrompts = [
    { id: "goal", label: "Mashg'ulot maqsadi nima edi va unga erishildimi?", placeholder: "Maqsad... Erishildi / qisman / yo'q, chunki..." },
    { id: "method", label: "Qaysi metod yoki usuldan foydalandim? Nima uchun aynan shu metod?", placeholder: "masalan: Qo'sh daraxt — bolalar bilimini tizimlashtirish uchun..." },
    { id: "success", label: "Nima yaxshi chiqdi? (2 yulduz)", placeholder: "1)... 2)..." },
    { id: "difficulty", label: "Qanday qiyinchilik yuz berdi va men qanday harakat qildim?", placeholder: "Vaziyat... Mening harakatim..." },
    { id: "next", label: "Keyingi safar nimani boshqacha qilaman? (1 tilak)", placeholder: "Keyingi mashg'ulotda..." },
];

export const moods = [
    { id: 1, emoji: "😟", label: "Qiyin bo'ldi" },
    { id: 2, emoji: "😐", label: "O'rtacha" },
    { id: 3, emoji: "🙂", label: "Yaxshi" },
    { id: 4, emoji: "😄", label: "A'lo" },
];

// Ijodiy topshiriq generatori uchun to'plamlar
export const challengePools = {
    ages: ["3–4 yosh (kichik guruh)", "4–5 yosh (o'rta guruh)", "5–6 yosh (katta guruh)", "6–7 yosh (maktabga tayyorlov guruhi)"],
    topics: ["Fasllar", "Uy hayvonlari", "Mening oilam", "Kasblar", "Transport", "Sabzavot va mevalar", "Navro'z bayrami", "Suv va uning xossalari", "Ranglar dunyosi", "Do'stlik", "Ona Vatan", "Kosmos", "Yo'l harakati qoidalari", "Sog'lom ovqatlanish"],
    formats: [
        "didaktik o'yin",
        "syujetli-rolli o'yin",
        "harakatli o'yin",
        "tajriba-eksperiment",
        "sayr davomidagi kuzatuv",
        "teatrlashtirilgan sahna",
        "loyiha faoliyati (1 hafta)",
        "ota-onalar ishtirokidagi tadbir",
    ],
    constraints: [
        "faqat tabiiy materiallardan (barg, tosh, qum) foydalaning",
        "mashg'ulot 15 daqiqadan oshmasin",
        "har bir bola kamida bir marta gapirsin",
        "bitta ham qog'oz ishlatmang",
        "musiqa elementi bo'lsin",
        "bolalar juftlikda ishlasin",
        "inklyuziv bo'lsin: imkoniyati cheklangan bola ham to'liq qatnashsin",
        "raqamli vosita (planshet, proyektor) ishlatilmasin",
    ],
};
